import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';

// 阅读站内信
export default async function ReadMessage(context: Context, params: CustomQuery): Promise<ApiResult> {
    const url = new URL('/mall/message/read', context.config.api.url);
    const { data: res } = await context.client.post(url.href, params);
    return res;
}
